
export const FicheEngagement = (props) => {

    return (
        <div className="fiche">
           {props.children}
        </div>
    )
}
